import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../constants/colors";

const Profile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "100px",
    transition: "0.3s",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const cards = [
    { to: "/view-profile", label: "View Profile", icon: "fa-book-open", color: colors.primary, text: "View your personal information and details." },
    { to: "/student-attendance", label: "Attendance", icon: "fa-clipboard-check", color: "#22c55e", text: "Check your attendance records." },
    { to: "/school-timetable", label: "My Timetable", icon: "fa-table", color: "#a855f7", text: "View your class schedule." },
    { to: "/school-achievement", label: "School Achievement", icon: "fa-medal", color: "#f59e0b", text: "View school-wide achievements." },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        

        {/* Grid: 1 column mobile, 3 columns desktop */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
          {cards.map((card, idx) => (
            <Link to={card.to} key={idx}>
              <div style={cardStyle} className="hover:scale-[1.02] transition">
                <i className={`fas ${card.icon}`} style={{ ...iconStyle, color: card.color }}></i>
                <div>
                  <h2 style={heading}>{card.label}</h2>
                  <p style={subText}>{card.text}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Profile;
